import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import classname from 'classnames';
import { EmbersMenuItem } from '../../../menuItem/menuItem';
import { EmbersButton } from '../../../button/button';
import { StyledMenu } from './tableMenuButtonStyles';
export var EmbersTableMenuButton = function EmbersTableMenuButton(_ref) {
  var options = _ref.options,
    btnText = _ref.btnText,
    onOptionClick = _ref.onOptionClick,
    disabled = _ref.disabled,
    className = _ref.className,
    _ref$maxActionNumberI = _ref.maxActionNumberInView,
    maxActionNumberInView = _ref$maxActionNumberI === void 0 ? 6 : _ref$maxActionNumberI;
  var intl = useIntl();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var open = Boolean(anchorEl);
  var _options = options.filter(function (v) {
    return !v.hidden;
  });
  var isSingleOption = _options.length === 1;
  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var handleOptionClick = function handleOptionClick(o) {
    handleClose();
    onOptionClick === null || onOptionClick === void 0 || onOptionClick(o);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classname('EmbersMenuButton', className)
  }, /*#__PURE__*/React.createElement(EmbersButton, _extends({
    disabled: disabled || isSingleOption && _options[0].disabled
  }, isSingleOption ? {
    startIcon: _options[0].prefixIcon ? /*#__PURE__*/React.createElement("span", {
      className: _options[0].prefixIcon
    }) : null,
    className: 'EmbersMenuButton-single'
  } : {
    'aria-controls': open ? 'table-actions-menu' : undefined,
    'aria-haspopup': 'true',
    'aria-expanded': open ? 'true' : undefined,
    endIcon: /*#__PURE__*/React.createElement("span", {
      className: "icon-expand-more"
    })
  }, {
    onClick: isSingleOption ? function () {
      return handleOptionClick(_options[0]);
    } : handleClick
  }), isSingleOption ? _options[0].label : btnText || intl.formatMessage({
    id: 'embers.table.actions',
    defaultMessage: 'Actions'
  })), !isSingleOption && /*#__PURE__*/React.createElement(StyledMenu, {
    id: "table-actions-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    menuScrollProps: {
      maxMenuNumberInView: maxActionNumberInView
    }
  }, _options.map(function (o, index) {
    return /*#__PURE__*/React.createElement(EmbersMenuItem, {
      key: o.value + '_' + index,
      value: o.value,
      prefixIcon: /*#__PURE__*/React.createElement("span", {
        className: o.prefixIcon || 'icon-add'
      }),
      onClick: function onClick() {
        handleOptionClick(o);
      },
      disabled: o.disabled
    }, o.label);
  })));
};